var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.2,
    height: 18.201,
    viewBox: "0 0 18.2 18.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".adelete{fill:#e24848;stroke:#e24848;stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-374.9 -602.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "adelete",
    d: "M139.74,424.9H126.665a.506.506,0,0,0-.375.125.409.409,0,0,0-.115.405l1.357,12.663a2.64,2.64,0,0,0,2.569,2.433h6.523a2.659,2.659,0,0,0,2.6-2.526l1.126-12.632a.573.573,0,0,0-.115-.374A4.162,4.162,0,0,0,139.74,424.9ZM138.095,438a1.561,1.561,0,0,1-1.559,1.466h-6.523a1.527,1.527,0,0,1-1.53-1.435l-1.3-11.977h11.949Z",
    transform: "translate(250.842 180.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adelete",
    d: "M136.9,419.3h-5.37v-.86a1.477,1.477,0,0,0-1.393-1.542h-3.367a1.452,1.452,0,0,0-1.48,1.453h0v.949h-5.37a.534.534,0,0,0,0,1.068h16.953a.526.526,0,0,0,.523-.534.486.486,0,0,0-.493-.534Zm-6.386-.86v.86h-4.151v-.86a.43.43,0,0,1,.348-.475h3.367a.385.385,0,0,1,.435.386h0Z",
    transform: "translate(255.6 186.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adelete",
    d: "M1269.968,1029.334v5.754a.532.532,0,0,1-.534.534h0a.532.532,0,0,1-.534-.534v-5.754a.532.532,0,0,1,.534-.534h0A.532.532,0,0,1,1269.968,1029.334Z",
    transform: "translate(-888.018 -419.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adelete",
    d: "M1278.668,1029.334v5.754a.532.532,0,0,1-.534.534h0a.532.532,0,0,1-.534-.534v-5.754a.532.532,0,0,1,.534-.534h0A.532.532,0,0,1,1278.668,1029.334Z",
    transform: "translate(-894.137 -419.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adelete",
    d: "M1287.468,1029.334v5.754a.532.532,0,0,1-.534.534h0a.532.532,0,0,1-.534-.534v-5.754a.532.532,0,0,1,.534-.534h0A.532.532,0,0,1,1287.468,1029.334Z",
    transform: "translate(-900.328 -419.144)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.caa9ffdd848ca0bb9d1f6f3cda10f29e.svg";
export { ForwardRef as ReactComponent };